import { Grid, Typography } from '@mui/material'
import { TooltipLabelIcon } from 'app/views/common-components/TooltipLabelIcon'
import { useField } from 'formik'
import {
  formElementsWithCustomTitleRender,
  formElementsWithoutDefaultTitle,
  formElementsWithoutFieldHistory
} from '../editor/GroupElement'
import { MUFieldComment } from '../multiuser/components/MUFieldComment'
import { MUPreviouslySavedValuesPanel } from '../multiuser/components/MUPreviouslySavedValuesPanel'
import { parseLabel } from '../parseLabel'
import { FormHelptext } from './FormHelpText'

export const FormElementTitle = ({
  tooltip,
  muBag,
  labelsWidth,
  id,
  altLabelPlacement,
  helpText,
  title,
  type,
  useMultiuser,
  disabled,
  showFieldLabel = false,
  item,
  connectedObject,
  required = false,
  targetFormType = 'editable'
}) => {
  const [field, meta] = useField(id)
  const isError = Boolean(meta.error && meta.touched)

  const showTitle = Boolean(
    !formElementsWithoutDefaultTitle.includes(type) &&
      !formElementsWithCustomTitleRender.includes(type) &&
      !showFieldLabel &&
      type !== 'errorList'
  )

  const parsedTitle = parseLabel(title)

  let width = 0
  if (altLabelPlacement) {
    width = 'initial'
  } else {
    width = '100%'
  }
  if (labelsWidth) {
    width = Number(labelsWidth)
  }

  return (
    <div
      style={{
        width
      }}
    >
      {showTitle && (
        <Grid
          item
          container
          alignItems='center'
          wrap='nowrap'
          justifyContent={altLabelPlacement ? 'flex-end' : 'flex-start'}
          style={{
            paddingRight: altLabelPlacement ? 10 : undefined
          }}
        >
          {targetFormType.includes('pdf') && (
            <Typography className='form-pdf-title'>
              {parsedTitle}
              {required && ' *'}
            </Typography>
          )}
          {targetFormType === 'printable' && (
            <Grid container wrap='nowrap' alignItems='center'>
              <Typography className='form-read-only-header'>
                {parsedTitle}
                {required && ' *'}
              </Typography>
              {tooltip && <TooltipLabelIcon tooltip={tooltip} />}
            </Grid>
          )}

          {targetFormType === 'editable' && (
            <Grid
              container
              wrap='nowrap'
              justifyContent={altLabelPlacement ? 'flex-end' : 'flex-start'}
              alignItems='center'
              style={{ textAlign: altLabelPlacement ? 'right' : 'left' }}
            >
              <Grid item>
                <Typography className='form-element-label form-parsed-text'>
                    {parsedTitle}
                    {required && (
                      <span style={{ color: Boolean(isError && title) && 'red' }}> *</span>
                    )}
                  </Typography>
              </Grid>
              <Grid item sx={{ display: 'flex', alignItems: 'center', marginTop: '-8px' }}>
                {tooltip && <TooltipLabelIcon tooltip={tooltip} />}
              </Grid>
            </Grid>
          )}

          {!formElementsWithoutFieldHistory.includes(type) && (
            <MUPreviouslySavedValuesPanel
              disabled={disabled}
              muBag={muBag}
              fieldId={id}
              type={type}
              connectedObject={connectedObject}
              item={item}
              useMultiuser={useMultiuser}
            />
          )}

          {useMultiuser && <MUFieldComment muBag={muBag} fieldId={id} />}
        </Grid>
      )}
      {helpText && !formElementsWithCustomTitleRender.includes(type) && (
        <FormHelptext helpText={helpText} />
      )}
    </div>
  )
}
